import * as Yup from "yup";
import { forceInt } from "Utils";
import { transform as userTransform } from "./User";

export const LockValidationSchema = Yup.object().shape({});

export const LockObjectSchema = {
    id: null,
    uuid: null,
    srn: null,
    user_id: null,
    state: null,
    created_at: null,
    modified_at: null,
};

export function transform(requestData) {
    if (requestData.data) {
        return requestData.data.map((item) => transform(item));
    }

    let lock = Object.assign({}, LockObjectSchema, {
        id: forceInt(requestData.id),
        uuid: requestData.uuid,
        srn: requestData.srn,
        user_id: requestData.user_id,
        state: requestData.state,
        created_at: requestData.created_at,
        modified_at: requestData.modified_at,
    });

    if (requestData.user) {
        let user = userTransform(requestData.user);
        lock = Object.assign({}, lock, { user: user });
    }

    return lock;
}
